import { i18n } from '@/i18n'
import { namedEntityLabel } from '@/lib/dropdownLabel.js'

const template = t => {
  const subtype = t.activity_subtype
  const l = [`(${t.id})`, namedEntityLabel(subtype) || subtype?.name || '']
  if (t.medicine_trademark) {
    l.push(namedEntityLabel(t.medicine_trademark))
  }
  if (t.laboratory) {
    l.push(t.laboratory.name)
  }
  return l.join(' ')
}
const activity = a => {
  const subtype = a.activity_subtype
  const l = [namedEntityLabel(subtype) || subtype?.name || '']
  if (a.medicine_trademark) {
    l.push(namedEntityLabel(a.medicine_trademark))
  }
  return l.join(' ')
}
function localeMap(prefix, keys, getKey = prop => `${prefix}.${prop}`) {
  return new Proxy(
    {},
    {
      get(_, prop) {
        if (typeof prop !== 'string' || prop === 'then' || !keys.includes(prop)) return undefined

        const key = getKey(prop)
        return i18n.global.te(key) ? i18n.global.t(key) : undefined
      },
      ownKeys() {
        return keys
      },
      getOwnPropertyDescriptor(_, prop) {
        return keys.includes(prop) ? { enumerable: true, configurable: true } : undefined
      },
      has(_, prop) {
        return keys.includes(prop)
      },
    }
  )
}

const uploads = localeMap('labels.uploads', [
  'order_reason',
  'act_pp',
  'act_pp_generated',
  'test_result',
  'others',
  'writeoff',
  'writeoff_signed',
  'payment_doc',
  'lab_order',
  'contract',
  'deviations',
  'analysis_certificates',
  'analysis_certificate_transfers',
  'specification',
  'destruction_request',
  'destruction_act',
  'attachments',
  'comment',
])

const actions = localeMap('labels.actions', ['delete', 'approve'])

const backLinkLabels = localeMap('common', ['stock.all.list'], () => 'common.back')

export { template, activity, uploads, actions, backLinkLabels }
